export default __webpack_public_path__ + "static/media/logo-dark.d472437b.png";